/// <summary>Cafm handlers object used to store functions by name, essentially to avoid using eval all over the place</summary>
cafm.handlers = {
    /// <field name='_handlers' type='Array'>Handler objects / functions array</field>
    _handlers: [],
    add: function (k, h) {
        /// <summary>Adds a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>
        /// <param name="h" type="Function">Handler function</param>

        var arr = this._handlers[k];
        if (!arr) {

            arr = [];
            this._handlers[k] = arr;
        }
        arr.push(h);
    },
    set: function (k, h) {
        /// <summary>Sets a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>
        /// <param name="h" type="Function">Handler function</param>

        this._handlers[k] = h;
    },
    get: function (k) {
        /// <summary>Gets a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>

        return this._handlers[k];
    },
    exists: function (k) {
        /// <summary>Checks for a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>

        return isFunc(this._handlers[k]);
    },
    remove: function (k) {
        /// <summary>Removes a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>

        delete this._handlers[k];
    },
    exe: function (k, e, e2, e3, e4, e5) {
        /// <summary>Executes a handler function</summary>
        /// <param name="k" type="String">Key for the handler</param>
        /// <param name="e" type="Object">Optional argument object</param>
        /// <param name="e2" type="Object">Optional second argument object</param>
        /// <param name="e3" type="Object">Optional third argument object</param>
        /// <param name="e4" type="Object">Optional fourth argument object</param>
        /// <param name="e5" type="Object">Optional fifth argument object</param>

        var h = this.get(k);
        if (isFunc(h)) {

            return h(e, e2, e3, e4, e5);
        }
        else if(isArray(h)){

            h.forEach(function (f) {

                f(e, e2);
            });
        }
        else {

            return cafm.util.callFunction(k, e, e2, true);
        }
    }
}